import React, { useRef, useState  ,useEffect} from "react";
import { ArrowRight, Envelope } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useContext } from "react";
import toast from "react-hot-toast";
import { Logindetail } from "../../context/Logindetail";
import OtpInput from "react-otp-input";
import { Box, Stack, Typography, TextField, useTheme } from "@mui/material";

const OTPForm = ({ formSubmitHandler, phone, phone_number_code, dailno,timerforshowresentotp, otpload, onResend }) => {
  const [invalid, setinvalid] = useState();
  const router = useNavigate();
  const [spinner, setspinner] = useState(false);
  const { setdetail_info, settoken } = useContext(Logindetail);
  const [otp, setOtp] = useState("");
  const theme = useTheme();


  // console.log("timerforshowresentotp", timerforshowresentotp)


  const initvalue = {
    otp: "",
    phone: phone,
  };

  const otpFormik = useFormik({
    initialValues: {
      otp: "",
      phone: phone,
    },
    validationSchema: Yup.object({
      otp: Yup.string().required("Enter your Otp"),
    }),
    onSubmit: async (values) => {
      try {
        // console.log(values,"dataa./././../.")
        formSubmitHandler(values);
      } catch (err) {}
    },
  });

   useEffect(() => {
    if (otpFormik.values.otp.length === 6 && !otpFormik.errors.otp) {
      otpFormik.submitForm();
    }
  }, [otpFormik.values.otp, otpFormik.errors.otp]);

  return (
    <>
      <div>
        <h5>
          Submit the OTP code sent to +{dailno?? ""} {phone ?? "your Phone Number"} and
          verify
        </h5>
        <form onSubmit={otpFormik.handleSubmit}>
          <Stack padding="0 20px" alignItems="center" justifyContent="center">
            <Box
              sx={{
                div: {
                  gap: "20px",
                },
                input: {
                  flexGrow: "1",
                  background: "transparent",
                  color: "#99131",
                  fontSize: "16px",
                  outline: "none",
                  height: "45px",
                  width: "45px !important",
                  borderRadius: "10px",
                  border: "1.6px solid " + "#99131",
                },
              }}
            >
              
              <OtpInput
                value={otpFormik?.values?.otp || ""}
                onChange={(otp) => otpFormik.setFieldValue("otp", otp)}
                numInputs={6}
                onBlur={otpFormik.handleBlur("otp")}
                shouldAutoFocus={true}
                renderInput={(props) => <input {...props} />}
                error={otpFormik.touched.otp && Boolean(otpFormik.errors.otp)}
              />

              {otpFormik.touched.otp && otpFormik.errors.otp ? (
                <span className="text-danger">{otpFormik.errors.otp}</span>
              ) : null}
            </Box>
          </Stack>

          <div className="login-footer text-center border-0 mt-4 d-block">
            <button className="text-white" disabled={otpload} type="submit">
              {otpload ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                ></span>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>

        {timerforshowresentotp ===  0 && (
        <div className="text-center mt-3 resend-otp-container" onClick={onResend} style={{ cursor: 'pointer' }}>
          <h5 className="resend-otp-text">Resend Otp</h5>
          <hr className="resend-otp-line" />
        </div>
        )
      }

       {timerforshowresentotp > 0 && (
        <div className="text-center mt-3 resend-otp-container"  style={{ cursor: 'pointer' }}>
           <h5 className="resend-otp-text">{timerforshowresentotp} seconds</h5>
          <hr className="resend-otp-line" />
        </div>
        )
      }

      </div>
    </>
  );
};

export default OTPForm;
